export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20flatlay%20with%20diverse%20fashion%20items%20including%20sneakers%20hoodies%20t-shirts%20accessories%20and%20bags%20artistically%20arranged%20on%20warm%20cream%20linen%20texture%20soft%20natural%20window%20light%20casting%20gentle%20shadows%20editorial%20minimalist%20style%20with%20copy%20space%20at%20center%20harmonious%20neutral%20color%20palette%20high%20end%20magazine%20quality%20composition&width=1600&height=900&seq=hero-main-unique-2026&orientation=landscape"
          alt="HoobuySpreadsheet - Produtos premium selecionados da China"
          title="HoobuySpreadsheet - Encontre os melhores produtos"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6 drop-shadow-lg">
          HoobuySpreadsheet 2026: O Guia Completo para Encontrar os Melhores Produtos da China
        </h1>

        <p className="text-white/85 text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed drop-shadow-md">
          Descubra como usar o <strong className="text-white">hoobuyspreadsheet</strong> para encontrar roupas, sneakers e produtos premium da China com precos extremamente baixos e qualidade verificada.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center shadow-lg shadow-primary-500/25"
          >
            hoobuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm border-2 border-white/60 text-white font-semibold text-sm md:text-base rounded-full hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
          >
            buy it now
          </a>
        </div>

        {/* Trust Bar */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-8 md:mt-10">
          <span className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
            <i className="ri-checkbox-circle-fill text-primary-400"></i>
            Atualizado semanalmente
          </span>
          <span className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
            <i className="ri-shield-check-fill text-primary-400"></i>
            Produtos verificados
          </span>
          <span className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
            <i className="ri-guide-fill text-primary-400"></i>
            Guias de compra seguros
          </span>
        </div>
      </div>
    </section>
  );
}